var map = {
	"./de/mecha-active-btn.png": "PtEp",
	"./en/mecha-active-btn.png": "VPoM",
	"./es/mecha-active-btn.png": "Aqyj",
	"./fr/mecha-active-btn.png": "ZajW",
	"./ja/mecha-active-btn.png": "kfsh",
	"./ko/mecha-active-btn.png": "N99m",
	"./pt/mecha-active-btn.png": "NZRy",
	"./ru/mecha-active-btn.png": "UUUf",
	"./tc/mecha-active-btn.png": "YDGB",
	"./th/mecha-active-btn.png": "HqUM"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Aoz2";